import { mapGetters } from "vuex";

export const upgradeMixin = {
    computed: {
        ...mapGetters({
            currentUser: "currentUser",
            currentAccess: "currentAccess",
        }),

        showUpgradeModal() {
            return this.shouldShowUpgradeModal
        }

    },
    data() {
        return {
            shouldShowUpgrade: false,
            shouldShowUpgradeModal: false
        };
    },
    watch: {
        $route(to, from) {
            this.setPathAccess(to)
        }
    },
    created() {
        this.setPathAccess(this.$router.currentRoute.path)
    },
    methods: {
        showUpgrade() {
            this.shouldShowUpgradeModal = !this.shouldShowUpgradeModal;
        },

        setPathAccess(path) {

            if (this.currentUser.isOnFree || this.currentUser.isOnDance) {
                switch (path) {
                    case "/library":
                        this.shouldShowUpgrade = !this.currentAccess.resourceAccess
                        break;
                    case "/library/videos":
                        this.shouldShowUpgrade = !this.currentAccess.videoLibraryAccess
                        break;
                    case "/toolbox":
                    case "/toolbox/pupils":
                    case "/toolbox/clubs":
                    case "/toolbox/crews":
                        this.shouldShowUpgrade = !this.currentAccess.toolboxAccess
                        break;
                    case "/events":
                        this.shouldShowUpgrade = !this.currentAccess.eventAccess
                        break;
                    case "/activities":
                        this.shouldShowUpgrade = !this.currentAccess.ecAccess
                        break;
                    case "/planning-add":
                        this.shouldShowUpgrade = !this.currentAccess.planningAccess
                        break;
                    case "/health":
                    case "/health/measures":
                    case "/health/taskgroups":
                        this.shouldShowUpgrade = !this.currentAccess.healthAccess
                        break;
                    case "/reports":
                        this.shouldShowUpgrade = !this.currentAccess.reportingAccess
                        break;
                    case "/dance":
                    case "/dance/CPD":
                    case "/dance/extra":
                    case "/dance/documents/lesson":
                        if (this.currentUser.isOnDance) {
                            this.shouldShowUpgrade = false
                        } else {
                            this.shouldShowUpgrade = !this.currentAccess.danceAccess
                        }

                        break;
                    default:
                    // code block
                }


                this.shouldShowUpgradeModal = this.shouldShowUpgrade
            }

        }

    }
}